import { useState } from "react";
import { useT } from "../lib/i18n";
import { Icon } from "./Icon";

// Optional image shown with a question. Renders nothing without a URL, and a
// readable placeholder (not a broken-image icon) when the URL fails — on a
// projector a broken image reads as "the app is broken".
export function QuestionImage({ src, className }: { src?: string | null; className?: string }) {
  // Track the exact URL that failed, so the next question starts fresh.
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const t = useT();

  if (!src) return null;

  if (failedSrc === src) {
    return (
      <div className="rounded-card bg-surface2 border border-line px-6 py-6 text-center text-ink/55 max-w-md flex flex-col items-center gap-2">
        <Icon name="image" size="1.5rem" className="text-ink/35" />
        <span className="text-sm">{t("imageFailed")}</span>
        <span className="text-ink/35 text-xs">{t("imageFailedHint")}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      onError={() => setFailedSrc(src)}
      className={className ?? "max-h-[38vh] w-auto rounded-card object-contain mx-auto"}
    />
  );
}
